import { statusField } from "../../../../helper/validField";
import { BcFieldProps } from "../../../interface/props/bcfield";
import { BCSelect, BCSelectCont } from "../../../styled/global.styled";

const SelectField = ({ field, register, isRequired, errors, touchedFields, dirtyFields }: BcFieldProps) => {
  
  return (
    <div className="bc-form-field">
      <BCSelectCont>
        <BCSelect
          className={`bc-input ${statusField(errors[field.item], touchedFields[field.item], !dirtyFields[field.item], !errors[field.item])}`}
          id={field.item}
          aria-label={field.label}
          {...register(field.item, { required: isRequired })}
        >
          <option
            value=""
          >{`Selecciona el/la ${field.placeholder}`}</option>
          {field?.options?.map((option: any) => (
            <option key={option.value} value={option.value}>
              {option.name}
            </option>
          ))}
        </BCSelect>
        <label htmlFor={field.item}>{field.label}</label>
        <span>{errors[field.item] ? 'Este campo es Obligatorio *' :  'Campo Obligatorio *'} </span>
      </BCSelectCont>
    </div>
  );
};

export default SelectField;
